export default __webpack_public_path__ + "static/media/police.5fe5e933.mp3";